import { uuid } from "vue-uuid";
import { mapGetters } from 'vuex';

export default {
    inject: ["mixpanel"],
    methods: {
        getValidUserUuidMixin(userUuidQuery) {
            const invalidValues = ['null', null, 'undefined', undefined, 'false', false, 'true', true];
            const userUuid = this.$route.query.web_user_id
              || this.$route.query.web_user_uuid
              || localStorage.getItem('web_user_uuid');
            return invalidValues.some(value => userUuid === value) ? null : userUuid;
        },
        generateUserIdMixin() {
            let userUuid = this.getValidUserUuidMixin();

            if (!userUuid) {
                userUuid = uuid.v4();
            }
            this.$store.commit('SET_UUID', userUuid);
            localStorage.setItem('web_user_uuid', userUuid)
        },
        sendUserIdToMixpanelMixin() {
            this.mixpanel.identify(this.userUuid);
            this.$tracker.setUserID(this.userUuid);
        }
    },

    computed: {
        ...mapGetters({
            userUuid: 'userUuid',
        }),
    }
}
